import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import usePromise from '@exchange/libs/composables/shared/src/lib/usePromise';
import { modalVariant } from '@exchange/libs/modals/src';
import { subaccountsService } from '@exchange/libs/trading-accounts/service/src';
import { useInitTransaction } from '@exchange/libs/transactions/funds/service/src';
import { CoinSelect } from '@exchange/libs/transactions/shared/src';
import TransactionModal from '@exchange/libs/transactions/shared/src/lib/TransactionModal.vue';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';

import TransferSubaccount from './TransferPaymentMethod.vue';

/**
 * To open modal, navigate to route with 'Transfer' hash;
 * To preselect currency - add 'currency' query param with the value of desired currency code
 * To preselect source account - add 'source' query param with the value of desired account name. If not provided "Main" will be used
 * To preselect destination account - add 'destination' query param with the value of desired account name
 *
 * Example router.push({ hash: '#Transfer', query: { currency: 'BTC', destination: 'kartoffel' } });
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'Transfer',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const { listWithInstantTrade, fetchList: fetchSubaccounts, getAccountByProp } = subaccountsService;

const variant = modalVariant.dark;
const preselectedFrom = ref<string | undefined>();
const preselectedTo = ref<string | undefined>();

const getAccountByName = getAccountByProp('name');

const {
  currenciesToShow,
  defaultFiatCurrency,
  filterCurrencyList,
  getAndRemoveParamsFromRouteQuery,
  resetSelectedCurrency,
  selectedCurrency,
  waitForCurrenciesWithTimeLimitAndSetSelectedOne,
  search,
} = useInitTransaction({ withAutomaticSwitchToMain: false });

const getPreselectedValues = async () => {
  const [source, destination, currency] = await getAndRemoveParamsFromRouteQuery(route, router, ['source', 'destination', 'currency']);

  waitForCurrenciesWithTimeLimitAndSetSelectedOne(currency);

  if (typeof destination === 'string') {
    preselectedTo.value = getAccountByName(destination)?.name;
  }

  let sourceNameToUse = CONSTANTS.MAIN_SUBACCOUNT_NAME;

  if (typeof source === 'string' && preselectedTo.value !== CONSTANTS.INSTANT_TRADE_ACCOUNT_NAME) {
    sourceNameToUse = source;
  }

  preselectedFrom.value = getAccountByName(sourceNameToUse)?.name;
};

const { loading: loadingSubaccounts, createPromise: onCreated } = usePromise(async () => {
  await fetchSubaccounts();
  await getPreselectedValues();
});

onCreated();

return (_ctx: any,_cache: any) => {
  const _component_ot_search = _resolveComponent("ot-search")!
  const _component_ot_loading_indicator = _resolveComponent("ot-loading-indicator")!

  return (_openBlock(), _createBlock(TransactionModal, {
    class: "transfer-modal",
    name: "transfer",
    variant: _unref(variant),
    title: _ctx.$t('modules.transactions.subaccountTransfer.transfer')
  }, {
    content: _withCtx(({ searchClass, coinSelectClass, contentClass }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["transfer-modal__search", searchClass])
      }, [
        _createVNode(_component_ot_search, {
          value: _unref(search),
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : null)),
          variant: _unref(variant),
          "full-width": true,
          "on-search-cb": _unref(filterCurrencyList),
          onInputClick: _unref(resetSelectedCurrency)
        }, null, 8, ["value", "variant", "on-search-cb", "onInputClick"])
      ], 2),
      _createVNode(_unref(CoinSelect), {
        selectedCurrency: _unref(selectedCurrency),
        "onUpdate:selectedCurrency": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedCurrency) ? (selectedCurrency).value = $event : null)),
        type: "transfer",
        variant: _unref(variant),
        class: _normalizeClass(coinSelectClass),
        currencies: _unref(currenciesToShow),
        "default-fiat-currency": _unref(defaultFiatCurrency),
        balances: undefined
      }, null, 8, ["selectedCurrency", "variant", "class", "currencies", "default-fiat-currency"]),
      (_unref(selectedCurrency))
        ? (_openBlock(), _createBlock(_component_ot_loading_indicator, {
            key: 0,
            until: _unref(loadingSubaccounts)
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(TransferSubaccount, {
                key: _unref(selectedCurrency).id,
                class: _normalizeClass(contentClass),
                variant: _unref(variant),
                accounts: _unref(listWithInstantTrade),
                currency: _unref(selectedCurrency),
                "should-disable-select": false,
                "preselected-from": preselectedFrom.value,
                "preselected-to": preselectedTo.value
              }, null, 8, ["class", "variant", "accounts", "currency", "preselected-from", "preselected-to"]))
            ]),
            _: 2
          }, 1032, ["until"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["variant", "title"]))
}
}

})